<template>

    <nav-bar :checkAction="reportStore.activeIconNavBar" :returnAction="true" :pageName="'Relato'" @check="reportStore.executeVisualize(patientId, reportStore.report)" @return="$router.push(`/patients/${this.patientId}/reports/`)" />
    
    <main-container :onlyNav="true">
        <div class="row w-100">
            <div class="col-sm-12 d-flex">                
                <label for="recipient-name" class="col-form-label fw-bold fs-3">{{reportStore.report.title}}</label>                                
            </div>
            <div class="col-sm-12 no-padding-bottom">
                <label for="recipient-name" class="col-form-label no-padding-bottom">{{`Paciente: ${patientStore.patient.name}`}}</label>                
            </div>
            <div class="col-sm-12 d-flex">                 
                <HumorEmojis :humor="reportStore.report.humor" />
                <div class="d-flex align-items-center px-2">
                    <label for="col-form-label">{{`(${convertHumor(reportStore.report.humor)})`}}</label>                
                </div>                
            </div>             
            <div class="col-sm-12 no-padding-bottom">
                <label for="recipient-name" class="col-form-label no-padding-bottom">{{`Data: ${formatShortDate(reportStore.report.date)} (${convertPeriod(reportStore.report.period)})`}}</label>                
            </div>            
            <div class="col-sm-12 no-padding-top">
                <label for="recipient-name" class="col-form-label">{{`Data de Criação: ${formatFullDate(reportStore.report.createdAt)}`}}</label>                
            </div>                                        
            <div class="col-sm-12 mb-1 fw-bold">                
                <label for="col-form-label">Relato</label>                
                <font-awesome-icon icon="check-double" class="blue px-2" v-if="reportStore.report.viewingDate"/>    
                <textarea class="form-control custom-textarea" id="exampleFormControlTextarea1" v-model="reportStore.report.description" disabled></textarea>
            </div>
        </div>
    </main-container>
    
</template>

<script>
import HumorEmojis from "../../components/Humor/HumorEmojis.vue";
import { useReportStore } from "../../store/report";
import { usePatientStore } from "../../store/patient";
import { convertHumor, convertPeriod, formatShortDate, formatFullDate } from "../../services/formatters";

export default {
    name:"PatientReportReadingView",    
    inject:["mySpinner"],    
    components: {
        HumorEmojis,
    },
    props: {
        patientId:{type:String},
        reportId:{type:String}
    },
    setup() {
        const reportStore  = useReportStore();
        const patientStore = usePatientStore();
        return { reportStore, patientStore }
    },
    async mounted() {         
        this.mySpinner.loading = true;                   
        await this.reportStore.getReportById(this.reportId);
        if (this.reportStore.report.viewingDate) 
            this.reportStore.activeIconNavBar = false;        
        else 
            this.reportStore.activeIconNavBar = true;        
        this.mySpinner.loading = false;
    },        
    methods: {
        convertHumor,
        convertPeriod,
        formatShortDate,
        formatFullDate
    }  
}
</script>

<style lang="css" scoped>
    @import'../../assets/css/_colors';
    @import'../../assets/css/_patients';
</style>
